<template>
  <div class="content">
    <!--1.头部-->
    <header-frame @show-nav="(flag) => (hidden = flag)" />
    <div v-show="!hidden">
      <!--3.一级导航-->
      <first-menu></first-menu>

      <div class="wrap">
        <!-- 二级菜单 -->
        <div class="second-menu">
          <span
            v-for="(item, index) in secondMenu"
            :key="index"
            @click="getDefaultMenu(item.id)"
            :class="[query.name === item.name ? 'choice' : '']"
          >
            {{ item.name }}
          </span>
        </div>

        <div class="layout-name" v-if="!query.detailID">{{ query.name }}</div>

        <!-- 三级菜单 -->
        <div class="third-menu" v-if="query.third">
          <van-tabs
            @click="clickThird"
            v-model="active"
            :swipe-threshold="3"
            :ellipsis="false"
            class="tabs"
            :swipeable="true"
          >
            <van-tab :title="item.name" v-for="(item, index) in thirdMenu" :key="index">
              <!-- 四级菜单 -->
              <van-collapse v-if="query.fourth" v-model="activeNames" @change="change">
                <van-collapse-item
                  :title="fourth.name"
                  :name="fourth.id"
                  v-for="(fourth, fourthIndex) in fourthMenu"
                  :key="fourthIndex"
                >
                  <layout-panel
                    :layoutType="Number(fourth.type)"
                    :menuID="fourth.id"
                  ></layout-panel>
                </van-collapse-item>
              </van-collapse>

              <!-- 不存在四级菜单时，直接显示内容 -->
              <layout-panel :layoutType="Number(item.type)" :menuID="item.id" v-else></layout-panel>
            </van-tab>
          </van-tabs>
        </div>

        <!-- 不存在三级菜单时，直接显示内容 -->
        <layout-panel :layoutType="Number(query.type)" :menuID="query.second" v-else></layout-panel>
      </div>

      <!--10.footer-->
      <footer-frame></footer-frame>
    </div>
  </div>
</template>

<script>
import { handleMenu, genQuery } from '@/assets/js/handleMenu.js';
import LayoutPanel from '@/pages/content/Layout';
import HeaderFrame from '@/components/Header';
import FirstMenu from '@/components/FirstMenu';
import FooterFrame from '@/components/Footer';

export default {
  components: {
    HeaderFrame,
    FirstMenu,
    FooterFrame,
    LayoutPanel,
  },
  data() {
    return {
      active: 0,
      swipeThreshold: 4,
      activeNames: [], // 默认激活的四级菜单ID
      secondMenu: [], // 二级菜单数据
      thirdMenu: [], // 三级菜单数据
      fourthMenu: [], // 四级菜单数据
      hidden: false,
    };
  },
  computed: {
    query() {
      return this.$route.query;
    },
  },
  watch: {
    $route() {
      if (this.query.first) {
        this.getSecondMenu();
      }
      if (this.query.second) {
        this.getThirdMenu();
      }
      if (this.query.third) {
        this.getFourthMenu();
      }
    },
    '$route.query.second'() {
      this.active = this.query.sort;
    },
  },
  mounted() {
    // this.getDefaultMenu(this.query.second)
    if (this.query.sort) {
      this.active = this.query.sort;
    } else {
      this.active = 0;
    }
    if (this.query.fourth) {
      this.activeNames = [Number(this.query.fourth)];
    } else {
      this.activeNames = [];
    }
    this.getSecondMenu();
    this.getThirdMenu();
    this.getFourthMenu();
  },
  methods: {
    // 获取二级菜单
    getSecondMenu() {
      let replacement = {
        menuID: this.query.first,
      };

      this.$api.getNextMenu(replacement).then((res) => {
        this.secondMenu = res;
      });
    },
    // 处理菜单函数
    getDefaultMenu(menuID) {
      let isSafari = false;
      if (
        /safari/.test(navigator.userAgent.toLowerCase()) &&
        !/chrome/.test(navigator.userAgent.toLowerCase())
      ) {
        isSafari = true;
      }

      let replacement = {
        menuID: menuID,
      };
      this.$api.getDefaultMenu(replacement).then((res) => {
        if (res.type === 15 || res.type === 16) {
          this.countClick(res.id);
        }
        if (res.type === 99) {
          if (isSafari) {
            document.location.href = res.url;
          } else {
            window.open(res.url, '_blank');
          }
        }
        let allMenu = handleMenu(res);

        let query = genQuery(allMenu);

        this.$router.push({
          path: 'content',
          query,
        });
      });
    },
    // 获取三级菜单
    getThirdMenu() {
      if (!this.query.second) {
        return;
      }

      let replacement = {
        menuID: this.query.second,
      };

      this.$api.getNextMenu(replacement).then((res) => {
        this.thirdMenu = res;
      });
    },
    // 获取四级菜单
    getFourthMenu() {
      if (!this.query.third) {
        return;
      }

      let replacement = {
        menuID: this.query.third,
      };

      this.$api.getNextMenu(replacement).then((res) => {
        this.fourthMenu = res;
      });
    },
    // 点击三级菜单，改变route
    clickThird(val) {
      this.getDefaultMenu(this.thirdMenu[val].id);
    },
    change(val) {},
    countClick(id) {
      let replacement = {
        articleID: id,
      };
      this.$api.countClick(replacement).then((res) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.wrap {
  margin-bottom: calc-width(30vw);
  padding: 0 calc-width(20vw);
}

.second-menu {
  padding-top: calc-width(15vw);
  margin-right: calc-width(-18vw);
  border-bottom: 1px solid $border-color;

  span {
    display: inline-block;
    margin-right: calc-width(20vw);
    margin-bottom: calc-width(15vw);
  }

  // 选中变蓝
  .choice {
    color: $primary-color;
  }
}

.layout-name {
  color: $primary-color;
  font-weight: bold;
  padding: calc-width(25vw) 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/content/index.vue